<template>
  <div class="h-100">
    <h5 class="card-text pt-3">
      Creative feedback
    </h5>
    <div class="card m-0 comment-wrapper">
      <div
        class="card-body o-auto p-0"
      >
        <ul class="list-group card-list-group">
          <li
            v-if="comments.length === 0"
            class="list-group-item py-5"
          >
            <small class="d-block text-muted">No comments for this item</small>
          </li>
          <CommentItem
            v-for="(commentItem, index) in comments"
            :key="index"
            :comment-item="commentItem"
          />
        </ul>
      </div>
      <div class="card-footer p-2">
        <div class="input-group">
          <textarea
            class="form-control"
            rows="3"
            spellcheck="false"
            placeholder="Feedback"
            style="resize: none;"
            v-model="newComment"
            @keydown.enter="handleEnter"
            data-test="feedback-textarea"
            :disabled="isCommentingDisabled"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-primary"
              @click="sendComment"
              :class="{ 'btn-loading': isLoading }"
              data-test="feedback-send-button"
              :disabled="isCommentingDisabled"
            >
              Send
            </button>
          </div>
        </div>
        <small
          v-if="currentAnnotationState"
          class="form-text text-muted mt-3"
        >
          <div
            class="annotation"
          />
          <span class="ml-5">Annotation reference added</span>
        </small>
        <small
          v-else
          class="form-text text-muted mt-3"
        >
          Send (keyboard shortcut)
          <kbd class="primary ml-3">ctrl + Enter</kbd>
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import * as types from '@/modules/content/store/types';

import CommentItem from '@/modules/account/components/CommentItem';

export default {
  name: 'Comments',
  components: {
    CommentItem,
  },
  props: {
    creativeSet: {
      type: Object,
      default: () => {},
    },
    contentItem: {
      type: Object,
      default: () => {},
    },
    isCommentingDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comments: [],
      newComment: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapState('content', [
      'creative',
      'currentAnnotationState',
      'selectedCreativeId',
    ]),
  },
  methods: {
    ...mapActions('content', [
      types.FETCH_CONTENT_COMMENTS,
      types.FETCH_CONTENT_COMMENTS_COUNT,
      types.POST_CONTENT_COMMENT,
      types.REMOVE_CURRENT_ANNOTATION,
    ]),
    fetchComments() {
      this.FETCH_CONTENT_COMMENTS({
        creativeId: this.creativeSet.id,
        contentId: this.contentItem.encodedExternalId,
      }).then((comments) => { this.comments = comments; });
    },
    handleEnter(e) {
      if (e.ctrlKey) return this.sendComment();
    },
    sendComment() {
      if (this.isLoading || this.isCommentingDisabled || this.newComment === '') {
        return;
      }
      this.isLoading = true;
      const payload = {
        creativeId: this.selectedCreativeId,
        body: {
          contentUuid: this.contentItem.encodedExternalId,
          comment: this.newComment,
        },
      };
      this.POST_CONTENT_COMMENT(payload)
        .then(() => {
          this.REMOVE_CURRENT_ANNOTATION();
          this.FETCH_CONTENT_COMMENTS_COUNT(this.selectedCreativeId);
          this.fetchComments();
          this.newComment = '';
          this.isLoading = false;
        });
    },
  },
  created() {
    if (this.contentItem && Object.keys(this.contentItem).length > 0) this.fetchComments();
  },
  watch: {
    contentItem: {
      handler() {
        if (this.contentItem && Object.keys(this.contentItem).length > 0) this.fetchComments();
      },
    },
  },
};
</script>
<style>
.comment-wrapper{
  height: calc(100% - 50px);
}
</style>
